/**
 * Underline tablist (shadcn-style, no Radix dependency yet).
 */
import { cn } from '../lib/utils';

export type PageTab<T extends string> = {
  id: T;
  label: string;
};

type Props<T extends string> = {
  tabs: Array<PageTab<T>>;
  active: T;
  onChange: (id: T) => void;
};

export default function PageTabs<T extends string>({ tabs, active, onChange }: Props<T>) {
  return (
    <div
      role="tablist"
      /*
       * Flush under the header — the dark bar already has its own padding, and
       * a second top margin made the strip float away from the title.
       */
      className="mb-3 flex h-10 w-full flex-nowrap items-stretch gap-0 overflow-x-auto overflow-y-hidden overscroll-x-contain border-b border-border [-ms-overflow-style:none] [scrollbar-width:thin] lg:mb-5 lg:mt-1 lg:h-11"
    >
      {tabs.map((tab) => {
        const isActive = tab.id === active;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.id)}
            className={cn(
              'inline-flex h-10 shrink-0 items-center border-b-2 px-3 text-sm leading-none transition-colors lg:h-11',
              isActive
                ? 'border-foreground font-medium text-foreground'
                : 'border-transparent font-medium text-muted-foreground hover:text-foreground',
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
